import type { Block, BlockCreate } from '@/types/blocks'

// Applies new theme/pattern to a cached block list in place (RTK Query
// optimistic draft) — the counterpart of `applyOrderUpdates` for reorder.
export function applyLookUpdates(
  items: Block[],
  updates: ReadonlyArray<{ id: number; body: BlockCreate }>,
): void {
  const lookById = new Map(updates.map((u) => [u.id, u.body]))
  for (let i = 0; i < items.length; i++) {
    const look = lookById.get(items[i].id)
    if (look) items[i] = { ...items[i], bgColor: look.bgColor, patternType: look.patternType }
  }
}
